export default __webpack_public_path__ + "static/media/property_198.404be53d.png";